import type { Organization } from './auth.service';

export type OrganizationClaims = Record<string, unknown>;

export interface OrganizationClaim {
  [organizationName: string]: {
    isTenant?: string[];
    logoUrl?: string[];
    id: string;
  };
}

export function getOrganization(
  claims: OrganizationClaims | null | undefined,
): Organization | undefined {
  return toOrganization(getOrganizationClaim(claims));
}

function toOrganization(
  claim: OrganizationClaim | undefined,
): Organization | undefined {
  if (claim == null) {
    return undefined;
  }

  const [org] = Object.keys(claim);

  if (org == null) {
    return undefined;
  }

  const organization = claim[org];

  if (organization == null) {
    return undefined;
  }

  // Keycloak organization attributes are always arrays; Multivalued=false does
  // not currently collapse them to scalars as documented.
  //    see https://github.com/keycloak/keycloak/issues/34164#issuecomment-2910313474
  const isTenant = organization.isTenant?.[0] === 'true';
  const id = organization.id;
  const logoUrl = organization.logoUrl?.[0];

  if (typeof id !== 'string' || id.length === 0) {
    return undefined;
  }

  return {
    id,
    name: org,
    isTenant,
    logoUrl,
  };
}

function getOrganizationClaim(
  claims: OrganizationClaims | null | undefined,
): OrganizationClaim | undefined {
  const value = claims?.['organization'];

  return value != null && typeof value === 'object' && !Array.isArray(value)
    ? (value as OrganizationClaim)
    : undefined;
}
